// tanstack
import { createFileRoute, Outlet } from '@tanstack/react-router';

// components
import ErrorBoundary from '@/routes/-ErrorBoundary';

export const Route = createFileRoute('/$accountId/_user/units')({
  component: Outlet,
  errorComponent: ErrorBoundary,
  staticData: { crumb: 'units-gateways-sensors:units.unitOverview' },
});
